@if (!selectedComponent()) {
    <div class="w-full">
        <app-card-content class="w-full empty-card" [border]="false" [icon]="'pi pi-folder-open'" [title]="'Serviços'" [subtitle]="'Nenhum serviço selecionado'">
            <div class="empty-body">
                <div class="empty-hero">
                    <i class="pi pi-folder-open empty-illustration text-primary"></i>
                </div>
                <h3 class="mt-3 mb-2 empty-title">Voce ainda nao selecionou um servico</h3>
                <p class="mb-4 text-color-secondary empty-description">Navegue pela lista de servicos ao lado e selecione aquele que deseja visualizar ou iniciar.</p>
                <!--
                    O seletor de conselho mora AQUI, no rodapé do card vazio, e não no shell do módulo:
                    para o perfil nacional escolher a UF é o primeiro passo do fluxo, e este card é a
                    tela em que ele cai ao entrar. `.empty-actions` já existia no SCSS como o slot de
                    ações deste card, sem uso até agora, e `.empty-body` já centraliza os filhos.
                -->
                @if (mostrarSeletorDeUf()) {
                    <div class="empty-actions empty-seletor-uf">
                        <span class="empty-seletor-uf-rotulo" id="empty-seletor-uf-rotulo">Conselho</span>
                        <app-estado-select aria-labelledby="empty-seletor-uf-rotulo" [uf]="ufSelecionada() ?? ''" [removeBR]="true" (ufChange)="onUfSelecionada($event)"></app-estado-select>
                    </div>
                }
            </div>
        </app-card-content>
    </div>
} @else {
    @if (protocoloSelecionado(); as protocoloSelecionado) {
        <div class="dashboard-detail">
            <div class="dashboard-detail-layout">
                <div class="dashboard-detail-panel">
                    <!--
                        Sem `title`/`icon`/`subtitle`: o cabeçalho dizia "Protocolo Portal" e repetia embaixo o
                        mesmo protocolo que o badge do card já anuncia — o card passou a se apresentar sozinho.
                        Sem eles o `app-card-content` não desenha header nenhum (é o `@if` dele), e por isso o
                        Voltar saiu do slot `card-header` e virou o canto superior direito do próprio card.
                    -->
                    <app-card-content>
                        <!--
                            Mesmo desenho do card do quadro: foto, e ao lado dela protocolo/nome/identificação
                            como um bloco só — os três respondem "quem é este protocolo". Os pares
                            "Rótulo: valor" que havia aqui empurravam o nome para o meio da lista, do mesmo
                            tamanho da data de tramitação. Sem moldura própria: este bloco já vive dentro do
                            card, e uma segunda borda viraria moldura dentro de moldura. Estilo em
                            shared/styles/_protocolo-card.scss, compartilhado com o quadro.
                        -->
                        <article class="protocolo-card">
                            <!-- Mesma linha do card do quadro: identificação à esquerda, ação na quina direita. -->
                            <div class="protocolo-card-topo">
                                <div class="protocolo-card-identificacao">
                                    <!--
                                        Sem trava por tipo de pessoa: a foto do diretor técnico da empresa já era
                                        buscada na pessoa jurídica (`carregarFotoDoMedico`) e simplesmente nunca
                                        chegava à tela, porque este bloco só desenhava em pessoa física.

                                        `rotuloAvatar` decide se o avatar é decorativo: vazio (pessoa física, onde
                                        a foto retrata o nome ao lado) mantém `aria-hidden`; preenchido (pessoa
                                        jurídica, onde o rosto é do diretor e o nome é o da empresa) vira o
                                        `alt`/`title` e tira o `aria-hidden` — senão nem o leitor de tela nem quem
                                        passa o mouse sabe de quem é aquele rosto.
                                    -->
                                    @if (protocoloSelecionado.avatar) {
                                        <!--
                                            Clique amplia o retrato, como na coluna de perfil das tabelas. O `title`
                                            fica no <span> porque o `p-image` não repassa o atributo; `appendTo="body"`
                                            tira o overlay de dentro do card, que tem recorte.
                                        -->
                                        <span class="protocolo-card-avatar--caixa" [title]="rotuloAvatar(protocoloSelecionado) || null" [attr.aria-hidden]="rotuloAvatar(protocoloSelecionado) ? null : true">
                                            <p-image
                                                [src]="protocoloSelecionado.avatar"
                                                [alt]="rotuloAvatar(protocoloSelecionado) || ''"
                                                [preview]="true"
                                                [appendTo]="'body'"
                                                styleClass="protocolo-card-avatar--clicavel protocolo-card-avatar--clicavel-grande"
                                                imageClass="protocolo-card-avatar protocolo-card-avatar--grande"
                                            />
                                        </span>
                                    } @else if (iniciaisAvatar(protocoloSelecionado); as iniciais) {
                                        <span
                                            class="protocolo-card-avatar protocolo-card-avatar--grande protocolo-card-avatar--iniciais"
                                            [attr.aria-label]="rotuloAvatar(protocoloSelecionado) || null"
                                            [title]="rotuloAvatar(protocoloSelecionado) || null"
                                            [attr.aria-hidden]="rotuloAvatar(protocoloSelecionado) ? null : true"
                                            >{{ iniciais }}</span
                                        >
                                    }

                                    <span class="protocolo-card-nomes">
                                        <span class="protocolo-badge">#{{ identificadorProtocolo(protocoloSelecionado) }}</span>
                                        <strong class="protocolo-card-solicitante">{{ unidadeNome() }}</strong>
                                        @if (identificacaoSolicitante(protocoloSelecionado); as identificacao) {
                                            <span class="protocolo-card-documento">{{ identificacao }}</span>
                                        }
                                    </span>
                                </div>

                                <button type="button" class="btn-voltar" (click)="voltarParaLista()">Voltar</button>
                            </div>

                            <dl class="protocolo-card-dados">
                                @if (protocoloSelecionado.isAnuidadePaga === false) {
                                    <div class="protocolo-card-dado">
                                        <dt><i class="pi pi-wallet" aria-hidden="true"></i> Anuidade</dt>
                                        <dd>Pendente</dd>
                                    </div>
                                }
                                <!--
                                    Quem é o diretor técnico por escrito, e não só no `title` da foto: o rosto
                                    ao lado do nome da EMPRESA não diz de quem é para quem enxerga e não passa
                                    o mouse. Mesma linha que o card do quadro traz.
                                -->
                                @if (protocoloSelecionado.diretorTecnicoNome) {
                                    <div class="protocolo-card-dado">
                                        <dt><i class="pi pi-user" aria-hidden="true"></i> Diretor técnico</dt>
                                        <dd>{{ protocoloSelecionado.diretorTecnicoNome }}{{ protocoloSelecionado.diretorTecnicoCrmUf ? ' · ' + protocoloSelecionado.diretorTecnicoCrmUf : '' }}</dd>
                                    </div>
                                }
                                @if (ultimaTramitacaoResumo(); as tramitacao) {
                                    <div class="protocolo-card-dado">
                                        <dt><i class="pi pi-clock" aria-hidden="true"></i> Última tramitação</dt>
                                        <dd [title]="tramitacao">{{ tramitacao }}</dd>
                                    </div>
                                }
                            </dl>

                            <!--
                                O texto continua em cada etiqueta ("Pago"/"Não pago", "DT: …"): a cor sozinha
                                não pode carregar o estado.
                            -->
                            <div class="protocolo-card-rodape">
                                <span class="protocolo-tag protocolo-tag--situacao" [class]="'protocolo-tag protocolo-tag--situacao situacao-' + situacaoProtocoloClasse(protocoloSelecionado.situacaoCodigo)">
                                    {{ situacaoProtocoloRotulo(protocoloSelecionado.situacaoCodigo) }}
                                </span>
                                @if (modalidadeInscricaoRotulo(protocoloSelecionado.modalidadeInscricao); as modalidade) {
                                    <span class="protocolo-tag protocolo-tag--modalidade">
                                        <i class="pi pi-id-card" aria-hidden="true"></i>
                                        {{ modalidade }}
                                    </span>
                                }
                                @if (protocoloSelecionado.inPago === false) {
                                    <span class="protocolo-tag protocolo-tag--pagamento protocolo-tag--pagamento-nao">Não pago</span>
                                }
                                @if (protocoloSelecionado.isAnuidadePaga === false) {
                                    <span class="protocolo-tag protocolo-tag--pagamento protocolo-tag--pagamento-nao">Anuidade não paga</span>
                                }
                                @if (indicacaoDiretorTecnicoRotulo(protocoloSelecionado.indicacaoDiretorTecnico); as indicacao) {
                                    <span class="protocolo-tag protocolo-tag--indicacao" [class]="'protocolo-tag protocolo-tag--indicacao indicacao-' + indicacaoDiretorTecnicoClasse(protocoloSelecionado.indicacaoDiretorTecnico)">
                                        DT: {{ indicacao }}
                                    </span>
                                }
                            </div>
                        </article>
                    </app-card-content>

                    @if (
                        (selectedComponent() === 'pre-prestador' ||
                            selectedComponent() === 'consultorio-privado' ||
                            selectedComponent() === 'cadastro-consultorio-privado' ||
                            selectedComponent() === 'consultorio-privado-renovacao' ||
                            selectedComponent() === 'renovacao-consultorio-privado') &&
                        exibirMenuAbasPrePrestador()
                    ) {
                        <aside class="detail-modulos">
                            <div class="detail-modulos-titulo">Abas</div>
                            <div class="detail-modulos-lista">
                                @for (modulo of modulosAbasAtivas; track modulo.value) {
                                    <button type="button" class="detail-modulo-item" [class.ativo]="abaPrePrestadorSelecionada() === modulo.value" (click)="selecionarAbaPrePrestador(modulo.value)">
                                        <i [class]="modulo.icon"></i>
                                        <span>{{ modulo.label }}</span>
                                    </button>
                                }
                            </div>
                        </aside>
                    }
                </div>

                <div class="dashboard-detail-content">
                    <app-card-servicos
                        [unidadeNome]="unidadeNome()"
                        [codigoEstado]="codigoEstado()"
                        [showEmail]="tipo() === 'pessoa-fisica' || tipo() === 'pessoa-juridica'"
                        [selectedCodigo]="selectedComponent()"
                        [protocoloSelecionado]="protocoloSelecionado"
                        [historicoTramitacoes]="historicoTramitacoes"
                        [carregandoHistorico]="carregandoHistorico"
                        [erroHistorico]="erroHistorico"
                        [inserindoHistorico]="inserindoHistorico"
                        [erroInsercaoHistorico]="erroInsercaoHistorico"
                        [confirmandoSolicitacao]="confirmandoSolicitacao"
                        [sucessoConfirmacaoSolicitacao]="sucessoConfirmacaoSolicitacao"
                        [erroConfirmacaoSolicitacao]="erroConfirmacaoSolicitacao"
                        [crmGeradoConfirmacao]="crmGeradoConfirmacao"
                        [abaPrePrestadorSelecionada]="abaPrePrestadorSelecionada()"
                        (historico)="onHistoricoSelecionado()"
                        (visualizar)="onVisualizarSelecionado()"
                        (inserirHistorico)="onInserirHistoricoSolicitado($event)"
                        (cancelarSolicitacao)="onCancelarSolicitacao()"
                        (confirmarSolicitacao)="onConfirmarSolicitacao($event)"
                        [(avisoPendenciaSolicitado)]="avisoPendenciaSolicitado"
                        (visibilidadeAbasConsultorioAlterada)="onVisibilidadeAbasConsultorioAlterada($event)"
                    ></app-card-servicos>
                </div>
            </div>
        </div>
    } @else {
        <div class="dashboard-layout protocolos-list-layout">
            <div class="pb-5 w-full dashboard-panel dashboard-panel-wide">
                <app-quadro-protocolos
                    [serviceName]="serviceTitle()"
                    [itens]="itensProtocolos"
                    [carregando]="carregandoProtocolos"
                    [exibirFiltroAnuidade]="selectedComponent() === 'pre-prestador'"
                    [tipoPessoa]="tipo()"
                    [idServico]="idServico()"
                    [uf]="ufCrm()"
                    [codigoServico]="selectedComponent()"
                    (itemSelected)="onItemSelected($event)"
                    (avisoPendenciaSolicitado)="onAvisoPendenciaSolicitado($event)"
                    (encerrarEmLoteSolicitado)="dialogoEncerramentoLote.abrir($event.itens, $event.coluna, $event.colunaDestino)"
                ></app-quadro-protocolos>
            </div>
        </div>
    }
}

<p-dialog
    appDialogoPadrao="pi pi-ban"
    descricao="Justifique o cancelamento da solicitação."
    header="Motivo do cancelamento"
    [visible]="exibirDialogoMotivoCancelamento()"
    (visibleChange)="exibirDialogoMotivoCancelamento.set($event)"
    [style]="{ width: '32rem' }"
    (onHide)="fecharDialogoMotivoCancelamento()"
>
    <p class="mb-3 text-color-secondary">Informe o motivo do cancelamento. Ele sera registrado na tramitacao e enviado ao solicitante por e-mail.</p>
    <textarea pTextarea class="w-full" rows="4" maxlength="500" [ngModel]="motivoCancelamento()" (ngModelChange)="motivoCancelamento.set($event)" placeholder="Descreva o motivo do cancelamento"></textarea>

    <ng-template pTemplate="footer">
        <button pButton type="button" label="Voltar" class="p-button-text" (click)="fecharDialogoMotivoCancelamento()"></button>
        <button pButton type="button" label="Confirmar cancelamento" severity="danger" [disabled]="!motivoCancelamento().trim() || confirmandoSolicitacao" (click)="confirmarCancelamentoComMotivo()"></button>
    </ng-template>
</p-dialog>

<!--
    Fora do `@if` do quadro de propósito: o diálogo do lote sobrevive a uma recarga que destrua o
    `KanbanProtocolos`, do mesmo jeito que a fila que ele acompanha — e é por isso que o serviço da
    fila é provido aqui, e não lá dentro.
-->
<app-encerramento-lote #dialogoEncerramentoLote [codigoServico]="selectedComponent()" [uf]="ufCrm()" [tipoPessoa]="tipo()" [idServico]="idServico()" (recargaDoQuadroSolicitada)="recarregarQuadroAposLote()" />
